<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-briefcase title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.organizations' | transloco}}</p>
        <p>{{'menu.descriptions.organizations' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <ng-container *ngIf="(loggedUser.user.organizationUuid === undefined) || ('ROLE_SUPER_ADMIN' | userHasRole)">
                <button
                  *ngIf="'ROLE_ADMIN' | userHasRole"
                  [label]="'common.new' | transloco"
                  pButton
                  pRipple
                  class="md:mr-2 p-button-primary mb-2 md:mb-0"
                  routerLink="new"
                  icon="pi pi-plus"
                ></button>
                <button
                  *ngIf="'ROLE_ADMIN' | userHasRole"
                  [label]="'common.delete' | transloco"
                  [disabled]="selected.length == 0"
                  (click)="confirmAndDeleteSelected()"
                  pButton
                  pRipple
                  class="p-button-danger mb-2 sm:mb-0"
                  icon="pi pi-trash"
                ></button>
              </ng-container>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [value]="organizations"
          [totalRecords]="totalOrganizations"
          [responsive]="true"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width"></th>
              <th pSortableColumn="name">
                {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
              <th pSortableColumn="description">
                {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
              <th pSortableColumn="tenant.name" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}<p-sortIcon field="tenant.name"></p-sortIcon></th>
              <th class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-organization>
            <tr *ngIf="!loadingOrganizations" class="fadein">
              <td>
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox [value]="organization"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <a [routerLink]="organization.uuid + '/details'">{{organization.name}}</a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                {{organization.description}}
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="organization.tenant" [routerLink]="['/management/tenants', organization.tenant.uuid, 'details']">
                  {{organization.tenant.name}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="organization.uuid + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    *ngIf="(loggedUser.user.organizationUuid === undefined) || ('ROLE_SUPER_ADMIN' | userHasRole)"
                    (click)="confirmAndDelete(organization)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingOrganizations" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalOrganizations == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalOrganizations > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalOrganizations ? totalOrganizations : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalOrganizations}}
              {{(totalOrganizations > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="exchange">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.description"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="exchange"
          type="text"
        >
      </div>
    </div>
    <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
      <div class="col-12 form-field">
        <label for="tenant">{{'model.tenant' | transloco}}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          [(ngModel)]="currentFilters.tenantUuids"
          [placeholder]="'select.generic' | transloco"
          [options]="tenants"
          [filter]="true"
          styleClass="w-full"
          id="tenant"
          optionLabel="name"
          optionValue="uuid"
          filterBy="name"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button
        type="button"
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.description ||
          currentFilters.tenantUuids
        )"
        (onClick)="filtersVisible = false; applyFilters();"
        styleClass="p-button-primary mx-2 mt-2"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>

<app-tenants-confirmation *ngIf="confirmationVisible"
                          [toDelete]="organizationToDelete"
                          [typeToDelete]="'ORGANIZATION'"
                          [(visible)]="confirmationVisible"
                          (delete)="deleteOrganization(organizationToDelete.uuid)">
</app-tenants-confirmation>
